import React, { useEffect } from "react";
import { KTSVG } from "../../../../_metronic/helpers";
import { Modal } from "react-bootstrap-v5";
import { Category, ExperienceDetail } from "../../teamExperiences/models/ExperienceSummaryModel";
import { useHistory } from "react-router-dom";
import { EXPERIENCE_STATUS, EXPERIENCE_STATUS_LIST } from "../../teamExperiences/models/ExperienceStatus";
import { InfoHistory } from "./SectionInfoHistory";
import { formatPhone } from "../../../helpers/FormatInputs";
import { sanitizeHtml } from "../../../helpers/sanitizeHtml";
import { defaultProfileImage } from "../../../utils/constants";
import GenericTooltip from "../../../hooks/utils/GenericTooltip";

type Props = {
    open: boolean;
    experience: ExperienceDetail;
    onClose: (close: boolean) => void;
    isPartner?: boolean;
};

const DetailExperienceDrawer:React.FC<Props> = ({ open, onClose, experience, isPartner }) => {
    const history = useHistory()

    useEffect(() => {
    }, []);

    const handleCancel = () => {
        onClose(false);
    }

    return (<Modal show={open} 
        onHide={handleCancel}
        backdrop='static'
        dialogClassName='experience-detail-modal'
        contentClassName='experience-detail-content'
        backdropClassName='experience-detail-backdrop'
        className={`w-100`}>
        <div className={`admin-experience-details-container`}>
            {/* Header */}
            <div className="admin-experience-details-header">
                <h2 className="admin-experience-details-title">
                    {isPartner ? "Partners Experiences Details" : `Experience by ${ experience?.host?.firstName || '' } ${ experience?.host?.lastName || '' }`}
                </h2>
                <div className="rm-style-3 cursor-pointer" onClick={()=>onClose(false)}>
                    <KTSVG path="/media/svg/nobilis/closeX.svg" className="rm-style-4" />
                </div>
                {/* <div className="admin-experience-details-close">
                </div> */}
            </div>

            {/* Action */}
            <div className="admin-experience-details-action">
                <button className="tap-add-experience-2-btn-secondary" onClick={()=>history.push(`/experience/edit/${experience.id}`)}>
                    <span>Edit</span>
                </button>
            </div>

            {/* Card */}
            <div className="admin-experience-details-card">
                <div className="admin-experience-details-user">
                    <div className="admin-experience-details-id d-flex flex-row">
                        <div className="w-50">#{experience.id}</div>
                        <div className="w-50 text-end">{EXPERIENCE_STATUS_LIST.map((item)=>item.id == experience.status ? (item.name) : null)}</div>
                    </div>

                    {/* Partner info */}
                    {(() => {
                        const partner = (experience as any)?.submittedBy || (experience as any)?.submitted_by || experience?.host;
                        const partnerName = partner?.companyName || partner?.company_name || partner?.name || (partner?.firstName 
                            ? `${partner.firstName} ${partner.lastName || ''}`.trim() 
                            : 'N/A');
                        const partnerImg = partner?.logo || partner?.image || partner?.profilePicture || partner?.profile_picture || defaultProfileImage;
                        const partnerEmail = partner?.email ?? 'N/A';
                        const partnerPhone = partner?.phone ?? partner?.phoneNumber ?? 'N/A';

                        return (
                            <>
                                <div className="admin-experience-details-user-info">
                                    <img className="admin-experience-details-avatar" src={partnerImg} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} />
                                    <span className="admin-experience-details-name">
                                        {partnerName}
                                    </span>
                                </div>

                                <div className="admin-experience-details-contact">
                                    <div className="admin-experience-details-field">
                                        <span className="admin-experience-details-label">Email</span>
                                        <span className="admin-experience-details-value">
                                            {partnerEmail}
                                        </span>
                                    </div>

                                    <div className="admin-experience-details-field">
                                        <span className="admin-experience-details-label">Phone</span>
                                        <span className="admin-experience-details-value">
                                            {partnerPhone !== 'N/A' ? formatPhone(partnerPhone) : 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            </>
                        );
                    })()}
                </div>
            </div>

            {/* Section */}
            <div className="admin-experience-details-summary">
                <div className="admin-experience-details-summary-header">
                    <div className="admin-experience-details-summary-tags">
                        {(experience?.categories ?? []).map((item:Category,index:number)=>(
                            <span key={`categories-detail-${index}`}>{item.name}</span>
                        ))}
                    </div>

                    <h4 className="admin-experience-details-summary-title">
                        {experience?.title}
                    </h4>
                </div>

                <p className="admin-experience-details-summary-description" dangerouslySetInnerHTML={{ __html: sanitizeHtml(experience?.idealAudience) }}>
                </p>

                {/* Audience */}
                <div className="admin-experience-details-summary-audience">
                    <span>{Number(experience?.audienceType) == 2 ? 'Only Adults' : 'Family Friendly' }</span>
                    <span className="experience-preview-icon-default">
                        <GenericTooltip
                            title=""
                            message={Number(experience?.audienceType) == 2 
                                ? "This experience welcomes adult members only, aged 18 and above." 
                                : "This experience welcomes children and family members of all ages. Infants under 2 are free of charge."}
                            position="top"
                            theme="light"
                            iconPath="/media/svg/nobilis/info.svg"
                        />
                    </span>
                </div>

                {/* Host info */}
                {(() => {
                    const host = experience?.host || (experience as any)?.submittedBy || (experience as any)?.submitted_by;
                    const hostName = host?.firstName 
                        ? `${host.firstName} ${host.lastName || ''}`.trim() 
                        : (host?.name || 'N/A');
                    const hostImg = host?.profilePicture || host?.profile_picture || host?.image || defaultProfileImage;
                    const hostEmail = host?.email ?? 'N/A';
                    const hostPhone = host?.phone ?? host?.phoneNumber ?? 'N/A';

                    return (
                        <div className="admin-experience-details-summary-submitted">
                            <span className="admin-experience-details-summary-label">
                                Submitted by
                            </span>

                            <div className="admin-experience-details-summary-user">
                                <img src={hostImg} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} />
                                <strong>{hostName}</strong>
                            </div>

                            <div className="admin-experience-details-summary-meta">
                                <span>{hostEmail}</span>
                                <span>|</span>
                                <span>{hostPhone !== 'N/A' ? formatPhone(hostPhone) : 'N/A'}</span>
                            </div>
                        </div>
                    );
                })()}
            </div>
            {Array.isArray(experience.rejectionInfo) && experience.rejectionInfo.length > 0 ? (
                <InfoHistory items={experience.rejectionInfo} />
            ) : (!Array.isArray(experience.rejectionInfo) && experience.rejectionInfo ? (
                <InfoHistory items={[experience.rejectionInfo]} />
            ) : null)}

            {/* Footer */}
            <div className="admin-experience-details-footer">
                <div>&nbsp;</div>
                <div className="tap-add-experience-2-btn-main" role="button" onClick={()=>history.push(`/experience/detail/${experience.id}`)}>
                    <div className="tap-host-button-text tap-flex-center">
                        review the experience
                        &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                    </div>
                </div>
            </div>
        </div>

    </Modal>);
}

export { DetailExperienceDrawer }